export async function importModule() {
    return await import(/* webpackChunkName: "html2canvas" */ 'html2canvas');
}